import * as React from 'react';

import OfferBannerContext from '../context/OfferBannerContext';
import OfferBannerDetails from '../details/OfferBannerDetails';

import { __t, applyTranslations } from 'utils/language';
import { getOfferRenegotiationMessageKey } from 'utils/offers/offers';
import { FUNC_RETURN_NULL } from '../utils/offer-banner';

applyTranslations(require('./offer-banner-renegotiation.i18n.json'));

const MSG_KEY = 'offer_banner_renegotiation';

const OfferBannerRenegotiation: React.FC = () => {
  const context = React.useContext(OfferBannerContext);
  const {
    offer,
    updatedOffer,
    isBrand,
    renderPrimaryText = FUNC_RETURN_NULL,
    renderSecondaryText = FUNC_RETURN_NULL,
    renderStatus = FUNC_RETURN_NULL,
    renderDisclaimer = FUNC_RETURN_NULL,
    renderCreatorActions = FUNC_RETURN_NULL
  } = context;

  const primaryText = __t(`${MSG_KEY}.messages.important_change`);
  const secondaryTextKey = getOfferRenegotiationMessageKey(offer, updatedOffer);
  const secondaryText = __t(`${MSG_KEY}.messages.${secondaryTextKey}`);
  const statusText = __t(`${MSG_KEY}.messages.pending_acceptance`);

  return (
    <React.Fragment>
      <div className="offer-banner-renegotiation">
        {renderPrimaryText(primaryText)}
        {renderSecondaryText(`${secondaryText}:`)}
        <OfferBannerDetails
          offer={updatedOffer}
          budgetLabel={__t(`${MSG_KEY}.labels.new_budget_offer`)}
          textStyle="highlighted"
          showAdditionalCompensationDescriptions
        />
        <OfferBannerDetails
          offer={offer}
          budgetLabel={__t(`${MSG_KEY}.labels.agreed_budget`)}
        />
        {
          isBrand && renderStatus(statusText)
        }
        {
          !isBrand && renderCreatorActions()
        }
      </div>
      {renderDisclaimer('offer_binding')}
    </React.Fragment>
  );
};

export default OfferBannerRenegotiation;
